import { easeLinear } from '../ease';

export const DEFAULT_LIFE = Infinity;
export const DEFAULT_ATTRACITON_RADIUS = 1000;
export const DEFAULT_ATTRACTION_FORCE_SCALAR = 100;
export const DEFAULT_BEHAVIOUR_EASING = easeLinear;
export const DEFAULT_BEHAVIOUR_EASING_TYPE = 'easeLinear';
export const DEFAULT_RANDOM_DRIFT_DELAY = 0.03;
export const PARTICLE_ALPHA_THRESHOLD = 0.002;
export const PARTICLE_LENGTH_SQ_THRESHOLD = 0.000004;
export const DEFAULT_CROSS_TYPE = 'dead';
